import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { trackPageView } from '@/lib/track'
import type { CrmInteractionSurface } from '@beetlesense/shared'

// Captures a page_view for every route — the platform AND the public blade tools
// (/tools/*). A no-op until the visitor accepts analytics cookies (see lib/track.ts),
// so this is safe to mount globally.
function surfaceForPath(path: string): CrmInteractionSurface {
  if (path.startsWith('/tools')) return 'blade'
  if (/^\/(owner|pilot|inspector|admin)(\/|$)/.test(path)) return 'platform'
  return 'landing'
}

export function RouteTracker() {
  const { pathname } = useLocation()
  const last = useRef<string | null>(null)

  useEffect(() => {
    if (last.current === pathname) return
    last.current = pathname
    trackPageView(pathname, surfaceForPath(pathname))
  }, [pathname])

  return null
}

export default RouteTracker
